import { useSelector } from "../../../../redux-store";
import ShipmentDrivingReport from "./ShipmentDrivingReport";
import { selectCargoSplitsForCargo } from "../../../../ducks/data/cargos-splits-info";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

const ShipmentDrivingReportsForSplits = ({ cargoId }: { cargoId: string }) => {
  const { t } = useTranslation("split");
  const cargoSplits = useSelector(selectCargoSplitsForCargo(cargoId));
  if (!cargoSplits?.length) {
    return null;
  }

  return (
    <div className="mt-8 mb-2">
      <Typography variant="h2">Cargo splits logs:</Typography>
      {cargoSplits.map((split, i) => (
        <div key={i} className="mt-4">
          <div>Cargo with ref: {split.ref}</div>
          <br />
          {split.deleted ? (
            <Typography variant="body2" color="text.secondary">
              {t("fragmentDeleted")}
            </Typography>
          ) : (
            <ShipmentDrivingReport
              cargoId={split.cargoId}
              clientId={split.clientId}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default ShipmentDrivingReportsForSplits;
